export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading font-black text-primary-400 tracking-tight">
              97<span className="text-white">影视</span>
            </span>
            <p className="mt-4 text-sm text-white/50 leading-relaxed">
              97影视提供高清免费在线观看服务，海量电影电视剧全集免费看，流畅不卡顿秒播无广告，极速观影体验，满足高清免费看片需求。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '热门推荐', href: '#carousel' },
                { label: '最新动态', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '精彩预告', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                    className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">影视分类</h3>
            <ul className="space-y-2.5">
              {['动作电影', '喜剧片', '科幻片', '悬疑剧', '爱情片', '纪录片'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    onClick={(e) => { e.preventDefault(); scrollTo('#index'); }}
                    className="text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-white/40">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
            <div className="mt-6">
              <h3 className="text-sm font-semibold text-white mb-3">关注我们</h3>
              <div className="flex items-center gap-3">
                {['ri-weibo-line', 'ri-wechat-line', 'ri-live-line', 'ri-video-line'].map((icon) => (
                  <span
                    key={icon}
                    className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-white/50 hover:bg-primary-500 hover:text-white transition-all cursor-pointer"
                  >
                    <i className={`${icon} text-base`}></i>
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            &copy; 2026 97影视网. 本站所有资源均来自网络，仅供交流学习使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">免责声明</a>
            <a href="#faq" onClick={(e) => { e.preventDefault(); scrollTo('#faq'); }} className="text-xs text-white/30 hover:text-white/50 transition-colors cursor-pointer">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}